// extracted by mini-css-extract-plugin
export default {"owner":"G3uBXtorYaPekCv3yxuy"};